import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  disabled: { opacity: 0.4 },
  pressed: { opacity: 0.6 },
});
